import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { type Database, dbCan, useUpdateDatabase } from '@/entities/database';
import { InlineTitleEditor } from '@/shared/ui';

import styles from './DatabaseTitle.module.css';

const NAME_MAX = 100;

/** The database name; holders of `database.edit_details` click it to rename in place. */
export function DatabaseTitle({ database }: { database: Database }) {
  const { t } = useTranslation();
  const update = useUpdateDatabase(database.id);
  const [editing, setEditing] = useState(false);
  if (editing) {
    return (
      <div className={styles.edit}>
        <InlineTitleEditor
          name={database.name}
          label={t('databases.name')}
          className={styles.input}
          maxLength={NAME_MAX}
          onSave={(name) => update.mutateAsync({ name, expected_version: database.version })}
          onClose={() => {
            setEditing(false);
          }}
        />
      </div>
    );
  }
  if (!dbCan(database, 'database.edit_details')) {
    return <h1 className={styles.title}>{database.name}</h1>;
  }
  return (
    <h1 className={styles.title}>
      <span
        role="button"
        tabIndex={0}
        className={styles.button}
        title={t('databases.renameHint')}
        onClick={() => {
          setEditing(true);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setEditing(true);
          }
        }}
      >
        {database.name}
      </span>
    </h1>
  );
}
